import React, { useState, useEffect } from 'react';
import { CalendarX } from 'lucide-react';
import api from '../../services/api';
import '../../styles/MancatePresentazioni.css';
import '../../styles/MancatePresentazioniConsole.css';

/**
 * MancatePresentazioni — lo storico delle volte che non si e' presentato.
 *
 * DUE NUMERI, NON UNO
 * Il contatore che conta e' quello a dodici mesi: e' quello che si guarda
 * prima di dare un orario. Il totale sta accanto, piu' piccolo, perche'
 * tre assenze nel 2024 e tre nell'ultimo trimestre sono due situazioni
 * diverse e il numero da solo non lo direbbe.
 *
 * Non c'e' nessun giudizio e nessuna soglia che faccia qualcosa: la
 * schermata conta e mostra. Chi telefona sa cose che il gestionale non sa.
 */

const dataIta = (v) => {
    if (!v) return '—';
    const d = new Date(v);
    return isNaN(d) ? '—' : d.toLocaleDateString('it-IT', {
        day: '2-digit', month: 'long', year: 'numeric',
    });
};

const ora = (v) => {
    if (!v) return '';
    const d = new Date(v);
    return isNaN(d) ? '' : d.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
};

/* Singolare per 1, plurale dal 2 in su e per zero (Alex, 21/10/2026: «"1
   mancate presentazioni": si corregge il codice»). Il numero puo' arrivare
   come testo (un count di PostgreSQL), quindi si confronta il numero. */
export const testoMancate = (n) => (Number(n) === 1
    ? `${n} mancata presentazione`
    : `${n} mancate presentazioni`);

const MancatePresentazioni = ({ pazienteId, compatto = false }) => {
    const [dati, setDati] = useState(null);
    const [caricamento, setCaricamento] = useState(true);

    useEffect(() => {
        let attivo = true;
        api.get(`/agenda/mancate/${pazienteId}`)
            .then((r) => { if (attivo) setDati(r.data.data); })
            .catch(() => { if (attivo) setDati(null); })
            .finally(() => { if (attivo) setCaricamento(false); });
        return () => { attivo = false; };
    }, [pazienteId]);

    if (caricamento) return null;
    // Nessuna assenza: non si mostra niente. Un riquadro che dice "zero"
    // occupa spazio per dire che non e' successo nulla.
    if (!dati || !dati.mancate_totali) return null;

    return (
        <div className={`mp-wrap ${compatto ? 'compatto' : ''}`}>
            <div className="mp-testa">
                <CalendarX size={16} />
                <div>
                    <b>
                        {testoMancate(dati.mancate_12m)}
                        <small> negli ultimi 12 mesi</small>
                    </b>
                    {dati.mancate_totali > dati.mancate_12m && (
                        <span>{dati.mancate_totali} in tutto dall’inizio</span>
                    )}
                </div>
            </div>

            {!compatto && (
                <ul className="mp-elenco">
                    {dati.storico.map((x) => (
                        <li key={x.appuntamento_id} className={x.recente ? '' : 'vecchia'}>
                            <span className="mp-quando">
                                {dataIta(x.inizio)} <small>{ora(x.inizio)}</small>
                            </span>
                            <span className="mp-chi">
                                {x.medico_cognome
                                    ? `${x.medico_titolo || ''} ${x.medico_cognome}`.trim()
                                    : x.agenda || '—'}
                                {x.titolo ? ` · ${x.titolo}` : ''}
                            </span>
                            {!x.recente && <span className="mp-vecchia">oltre 12 mesi</span>}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default MancatePresentazioni;
